import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingUp, TrendingDown, Minus, MapPin, PlusCircle } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function WonkaDetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-3585" data-mp="q7zt04xph3ss">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-3586" data-mp="zzma2hwq5x3g">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-3587" data-mp="101qdyzumiw3q">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-3588" data-mp="14wvz3wg7c6qr">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-3589" data-mp="19ylbbff5uqgf">
            <div data-id="element-3590" data-mp="3bot6qdxjviyf">
              <p className="font-semibold text-gray-900" data-id="element-3591" data-mp="3bpcex2xeesz9">SOS State</p>
              <p className="text-gray-600" data-id="element-3592" data-mp="36ox0s95alhg8">PA</p>
            </div>
            <div data-id="element-3593" data-mp="36rt0a1wsge6s">
              <p className="font-semibold text-gray-900" data-id="element-3594" data-mp="31q3nohtx3sgl">Founded Date</p>
              <p className="text-gray-600" data-id="element-3595" data-mp="31sg3opg47sr0">1971</p>
            </div>
            <div data-id="element-3596" data-mp="2xq38guyzvd8h">
              <p className="font-semibold text-gray-900" data-id="element-3597" data-mp="2xql17hmg79bn">SOS Number</p>
              <p className="text-gray-600" data-id="element-3598" data-mp="3udzi1fw0l8a7">1971001</p>
            </div>
            <div data-id="element-3599" data-mp="3pg7nee3zj82b">
              <p className="font-semibold text-gray-900" data-id="element-3600" data-mp="3pfoajbt6z9v5">Type</p>
              <p className="text-gray-600" data-id="element-3601" data-mp="3kp7stfic922z">C-Corporation</p>
            </div>
            <div data-id="element-3602" data-mp="3kn4v09ay24np">
              <p className="font-semibold text-gray-900" data-id="element-3603" data-mp="3gnmahen1bvle">TIN Number</p>
              <p className="text-gray-600" data-id="element-3604" data-mp="3gndxlmqwwqa7">23-1971845</p>
            </div>
            <div data-id="element-3605" data-mp="h162vb75xwc2">
              <p className="font-semibold text-gray-900" data-id="element-3606" data-mp="h1pfqdhyhuj8">DBAs</p>
              <p className="text-gray-600" data-id="element-3607" data-mp="c95xv4c8kd8m">WONKA CHOCOLATE FACTORY</p>
            </div>
            <div data-id="element-3608" data-mp="26gqbgjg1ry1l">
              <p className="font-semibold text-gray-900" data-id="element-3609" data-mp="26ib4u5qmlaxv">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-3610" data-mp="2bgw70apfu4oy">Domestic</p>
            </div>
            <div data-id="element-3611" data-mp="2bi798638j4dy">
              <p className="font-semibold text-gray-900" data-id="element-3612" data-mp="1wrq7elmoucgj">Entity Type</p>
              <p className="text-gray-600" data-id="element-3613" data-mp="1wpdrsf4eke6n">Private Company</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-3614" data-mp="1nq8vzgk86yy6">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-3615" data-mp="1spliu1b3k60r">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-3616" data-mp="1sniioog8cwib">
            <div data-id="element-3617" data-mp="1du5kvl7ebpz3">
              <p className="font-semibold text-gray-900" data-id="element-3618" data-mp="1dup5j9ofksgt">SIC</p>
              <p className="text-gray-600" data-id="element-3619" data-mp="1isgsrqe4rqeo">2064 - CANDY & CONFECTIONERY</p>
            </div>
            <div data-id="element-3620" data-mp="387oqlibkyevh">
              <p className="font-semibold text-gray-900" data-id="element-3621" data-mp="38754dpewd4bn">Ticker</p>
              <p className="text-gray-600" data-id="element-3622" data-mp="3d5yk7ohnp7ez">--</p>
            </div>
            <div data-id="element-3623" data-mp="11icwqroguq3n">
              <p className="font-semibold text-gray-900" data-id="element-3624" data-mp="11htq4749no4x">NAICS</p>
              <p className="text-gray-600" data-id="element-3625" data-mp="11gab0jucjj4q">
                311352 - CONFECTIONERY MANUFACTURING
              </p>
            </div>
            <div data-id="element-3626" data-mp="1b8od5dpc6rrf">
              <p className="font-semibold text-gray-900" data-id="element-3627" data-mp="1b97w8xqq3m71">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-3628" data-mp="16gxyivjd9hu7">~$285 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-3629" data-mp="1k8kwr0wvd0fm">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-3630" data-mp="1k7jiknkk3xto">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-3631" data-mp="1g80ytv4h1ssf">
              Wonka Industries Ltd. is a world-renowned confectionery
              manufacturer specializing in innovative candy products. Known for
              the Everlasting Gobstopper, Wonka Bar, and other magical treats.
              "A little nonsense now and then is relished by the wisest men."
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-3632" data-mp="3qzanq8hvwbd7">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-3633" data-mp="3siu2i9n9k89r">
          <div className="flex justify-between items-start mb-2" data-id="element-3634" data-mp="1bzq5fn3zhdd">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-3635" data-mp="6aknn7az7my4">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-3636" data-mp="b8m91yvvjycr" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-3637" data-mp="39pzzme2x06lw">
            <p data-id="element-3638" data-mp="39rjfi3knsfn5">1 CHOCOLATE AVENUE</p>
            <p data-id="element-3639" data-mp="39o5eaynqecha">HERSHEY, PA 17033, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-3640" data-mp="3epuqwiqlqy7h">
            <img src="https://cdn.magicpatterns.com/uploads/jLJSKVWf6UT7uWfheF4Dvi/Gemini_Generated_Image_ju8ib2ju8ib2ju8i.png" alt="Wonka Chocolate Factory - Hershey, PA" className="w-full h-full object-cover" data-id="element-3641" data-mp="3jml0qobtcxkg" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3642" data-mp="1d3gum177rlh5">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-3643" data-mp="1d14e7sh3tj67">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3644" data-mp="142sft49zxh37">Legal Filings (3)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-3645" data-mp="144vfkg0yaol4">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-3646" data-mp="u6pd9xb8fgfq">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-3647" data-mp="bcsbb6jeq60v" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-3648" data-mp="6eie6qe4gvcm" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-3649" data-mp="6hcxufpbac4z" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-3650" data-mp="3sv7nmli2i6ia" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-3651" data-mp="3jw43rfb2tn2q">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3652" data-mp="3nx627tx65v3n">
              <div className="flex items-center gap-4" data-id="element-3653" data-mp="kgplf0et5l6l">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-3654" data-mp="kg7ffc2cfslh">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-3655" data-mp="6nhqozvfk9ko" />
                </div>
                <div className="text-left" data-id="element-3656" data-mp="apcs04dd2myg">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-3657" data-mp="yh0bi18amvqp">
                    <h4 className="font-bold text-gray-900" data-id="element-3658" data-mp="yenmj444bl45">
                      DAUPHIN COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Released" data-id="element-3659" data-mp="2nxm1dvoseg6e"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-3660" data-mp="2xnp6uvd3hmlm">
                    MECHANIC'S LIEN • RELEASED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-3661" data-mp="2sp45gsm3wwvl">
                <p className="font-medium text-gray-900" data-id="element-3662" data-mp="24yro6r4z1nsc">3/22/2017</p>
                <p className="text-sm text-gray-500" data-id="element-3663" data-mp="25144kzv2zq3a">$8,500</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3664" data-mp="2eysamly50k0r">
              <div className="flex items-center gap-4" data-id="element-3665" data-mp="3qb1gy622k1y1">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-3666" data-mp="3ldjhr7dut138">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-3667" data-mp="1ir4cqp6vi4ns" />
                </div>
                <div className="text-left" data-id="element-3668" data-mp="1npp6q6vj7s3s">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-3669" data-mp="1nqh2pit1jrul">
                    <h4 className="font-bold text-gray-900" data-id="element-3670" data-mp="1soa3txfhlvo0">
                      SLUGWORTH V. WONKA INDUSTRIES LTD.
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Dismissed" data-id="element-3671" data-mp="1xh3d8ylwhs6f"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-3672" data-mp="26evptv08mlq4">
                    CIVIL LAWSUIT • TRADE SECRET THEFT • DISMISSED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-3673" data-mp="2gemj5td2auom">
                <p className="font-medium text-gray-900" data-id="element-3674" data-mp="2gca5vti918hw">3/15/2018</p>
                <p className="text-sm text-gray-500" data-id="element-3675" data-mp="h2k4qxjaoqht">Dismissed</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3676" data-mp="eh2mvx7iubwf">
              <div className="flex items-center gap-4" data-id="element-3677" data-mp="4qhtco6pfxkd">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-3678" data-mp="4owxmv8nm8kx">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-3679" data-mp="3vvhk01nrksbm" />
                </div>
                <div className="text-left" data-id="element-3680" data-mp="xdm0ozt9snzb">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-3681" data-mp="sg28sx3ngcow">
                    <h4 className="font-bold text-gray-900" data-id="element-3682" data-mp="serahcsz3x56">
                      PNC EQUIPMENT FINANCE
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-blue-500" title="Active" data-id="element-3683" data-mp="iixq5790izcu"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-3684" data-mp="338n3tgxzcf3y">
                    UCC FILING • PRODUCTION EQUIPMENT
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-3685" data-mp="1z9dv4z0sqwvc">
                <p className="font-medium text-gray-900" data-id="element-3686" data-mp="1ucvry3l476l4">6/12/2024</p>
                <p className="text-sm text-gray-500" data-id="element-3687" data-mp="1uaj2z6gxvvyk">Active</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3688" data-mp="249ru7rkf6wh8">
        <div className="p-5 border-b border-gray-200" data-id="element-3689" data-mp="2i0n5tbmazroi">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3690" data-mp="2e0d0m16c55ap">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-3691" data-mp="2e2frsoj854h0">
          <table className="w-full text-sm text-left" data-id="element-3692" data-mp="2s0e0pees08p4">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-3693" data-mp="2ry1ir190pyc2">
              <tr data-id="element-3694" data-mp="2n1uct8gmgmu4">
                <th className="px-5 py-3 font-medium" data-id="element-3695" data-mp="2mz88risxwpgn">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-3696" data-mp="xmwdjsia9dum">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-3697" data-mp="snjod13xvuov">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3698" data-mp="349u09bxfzzyj">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3699" data-mp="34cgcvpz6x5nm">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-3700" data-mp="39858xjc044f6">
                  Mar 20, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-3701" data-mp="2uihff4a2aa20">
                  Wonka Industries Launches Revolutionary Everlasting Gobstopper
                  2.0 — Sales Surge 40% in First Week
                </td>
                <td className="px-5 py-4" data-id="element-3702" data-mp="2qip4wm13xtu0">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3703" data-mp="2qjqfkpe7oeb7">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-3704" data-mp="2gk9bgcely8hc" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3705" data-mp="9v4hd13dqsks">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-3706" data-mp="esd299fwxapq">
                  Feb 14, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-3707" data-mp="ddtsfnfkthm4">
                  Golden Ticket Promotion Drives Record Valentine's Day Sales —
                  Five Lucky Winners Announced
                </td>
                <td className="px-5 py-4" data-id="element-3708" data-mp="3g5pwbbqb5te">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3709" data-mp="3vine63f06kpt">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-3710" data-mp="r3nkeemdoi02" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3711" data-mp="mbmcf4w8tdfu">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-3712" data-mp="iblpswyzpvxp">
                  Jan 05, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-3713" data-mp="1eu9qi0ctns7f">
                  Wonka Industries Expands Distribution to 12 New Countries in
                  Asia-Pacific Region
                </td>
                <td className="px-5 py-4" data-id="element-3714" data-mp="2sqkuq1sapyz5">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3715" data-mp="2srm4m2xksffa">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-3716" data-mp="31oegwjwcjc8l" />
                    Positive
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3717" data-mp="3gmyoicwa7g8b">
        <div className="p-5 border-b border-gray-200" data-id="element-3718" data-mp="3ldxa9s01h6iy">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3719" data-mp="3legp2zue7esr">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-3720" data-mp="3phmr1vah2jtf">
          <table className="w-full text-sm text-left" data-id="element-3721" data-mp="3ufek4smusbz7">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-3722" data-mp="3uciojayh9zdx">
              <tr data-id="element-3723" data-mp="38lkvubmemxb">
                <th className="px-5 py-3 font-medium" data-id="element-3724" data-mp="35zcxtkti5ek">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-3725" data-mp="3lpocsd1p1jig">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-3726" data-mp="3gsfv0dkgjhhq">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-3727" data-mp="3gptnuf1hb401"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3728" data-mp="3vivk43fzv9l6">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3729" data-mp="3qir228zfu6su">
                <td className="px-5 py-3 text-indigo-600" data-id="element-3730" data-mp="32rv938j8x5k0">
                  WONKA INDUSTRIES INC.
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3731" data-mp="2xttv320ofwfe">Parent Company</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3732" data-mp="3cq1dbwsiyns1">US</td>
                <td className="px-5 py-3" data-id="element-3733" data-mp="3crm89nir48qf">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3734" data-mp="37qor9e9h9kqi">
                    Monitored
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3735" data-mp="uix9255uxfjm">
        <div className="p-5 border-b border-gray-200" data-id="element-3736" data-mp="zl62t3qk0lms">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3737" data-mp="lk3hit7dvfcx">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-3738" data-mp="plf40puynkgw">
          <table className="w-full text-sm text-left" data-id="element-3739" data-mp="pm6rfdeembw3">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-3740" data-mp="1db9j7e2r5l4b">
              <tr data-id="element-3741" data-mp="1ddc8fvw2za7z">
                <th className="px-5 py-3 font-medium" data-id="element-3742" data-mp="1i9t5jfl9cyx7">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-3743" data-mp="1i9b506rkbyjh">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-3744" data-mp="14hmrq05kv40x">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-3745" data-mp="18k19egxifxqm">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3746" data-mp="1wa3x6kue6hjf">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3747" data-mp="1w8kgit4tq4h4">
                <td className="px-5 py-3 text-gray-900" data-id="element-3748" data-mp="211lzpdc2cq6i">
                  WONKA CHOCOLATE FACTORY
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3749" data-mp="2aw10b9n82syh">
                  Headquarters / Factory
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3750" data-mp="26suvm6frd9u4">
                  1 Chocolate Avenue, Hershey, PA 17033
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3751" data-mp="1wx1kmrhotoeg">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3752" data-mp="1wz5rniavv3iy">
                <td className="px-5 py-3 text-gray-900" data-id="element-3753" data-mp="1rz9iz5r8qnx2">
                  WONKA DISTRIBUTION CENTER
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3754" data-mp="1n55c0mhz6fvz">Distribution Hub</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3755" data-mp="1j5wm5sq2325p">
                  500 Sweet Street, Chicago, IL 60601
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3756" data-mp="1977bajwkuhyy">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3757" data-mp="199bc2sz6j0v0">
                <td className="px-5 py-3 text-gray-900" data-id="element-3758" data-mp="149f82tqhf9fg">WONKA WEST COAST</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3759" data-mp="u4p5qmr623ap">Regional Office</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3760" data-mp="z3a2udb4g6ux">
                  100 Candy Lane, San Francisco, CA 94102
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3761" data-mp="143elo9zi5dob">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} company="wonka" data-id="element-3762" data-mp="bdxwdl76icwb" />}
    </div>;
}